import React from 'react';
import { serialize } from 'src/utils/serialize';

export const GuestAccess = ({
  title,
  subTitle,
  icon,
}: {
  title: string;
  subTitle?: string;
  icon?: JSX.Element;
}) => {
  const type = subTitle === 'board_task' ? 'task' : subTitle;
  return (
    <div>
      <div className="mr-8 flex">
        {icon && <span className="mr-12">{icon}</span>}
        <div>
          <span className="block text-gray-999 font-medium max-w-284 truncate">
            {Array.isArray(title) ? serialize(title) : title}
          </span>
          {subTitle && (
            <span className="text-gray-500 text-xs block mt-2">
              {type && type[0].toUpperCase() + type.substring(1)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
